import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';

export function hasRetargetingSegmentToSync(targeting?: TargetingBaseType): boolean {
  return Boolean(targeting?.audience && 'retargetingSegment' in targeting.audience);
}
